"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _propTypes = require("prop-types");

var _color = _interopRequireDefault(require("../../constants/color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RatingOption = function RatingOption(_ref) {
  var children = _ref.children,
      id = _ref.id,
      value = _ref.value,
      name = _ref.name,
      selected = _ref.selected,
      backgroundColor = _ref.backgroundColor,
      onChange = _ref.onChange,
      onMouseEnter = _ref.onMouseEnter,
      props = _objectWithoutProperties(_ref, ["children", "id", "value", "name", "selected", "backgroundColor", "onChange", "onMouseEnter"]);

  var allowedModifiers = {
    active: selected
  };
  var labelColor = ['co-rating__label', backgroundColor].join(' ').trim();
  return _react.default.createElement(_styler.default, {
    className: "co-rating__option",
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, (0, _getNativeProps.default)(props)), _react.default.createElement("input", {
      className: "co--visually-hidden",
      id: id,
      type: "radio",
      name: name,
      value: value,
      checked: selected,
      onChange: onChange
    }), _react.default.createElement("label", {
      htmlFor: id,
      onMouseEnter: onMouseEnter,
      className: labelColor
    }, children));
  });
};

RatingOption.displayName = 'Rating.Option';

var noop = function noop() {};

RatingOption.defaultProps = {
  onChange: noop,
  onMouseEnter: noop
};
RatingOption.propTypes = {
  children: _propTypes.any.isRequired,
  id: _propTypes.string,
  value: _propTypes.any,
  name: _propTypes.string,
  selected: _propTypes.bool,

  /** {const} One of: @@Color.background.orange[700]@@ @@Color.background.orange[500]@@ @@Color.background.yellow[600]@@ @@Color.background.green[500]@@ @@Color.background.green[700]@@ @@Color.background.gray[600]@@ */
  backgroundColor: (0, _propTypes.oneOf)([_color.default.background.orange[700], _color.default.background.orange[500], _color.default.background.yellow[600], _color.default.background.green[500], _color.default.background.green[700], _color.default.background.gray[600]]),
  onChange: _propTypes.func,
  onMouseEnter: _propTypes.func
};
var _default = RatingOption;
exports.default = _default;
RatingOption.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Rating.Option",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseEnter": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "selected": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "backgroundColor": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "Color.background.orange[700]",
          "computed": true
        }, {
          "value": "Color.background.orange[500]",
          "computed": true
        }, {
          "value": "Color.background.yellow[600]",
          "computed": true
        }, {
          "value": "Color.background.green[500]",
          "computed": true
        }, {
          "value": "Color.background.green[700]",
          "computed": true
        }, {
          "value": "Color.background.gray[600]",
          "computed": true
        }]
      },
      "required": false,
      "description": "{const} One of: @@Color.background.orange[700]@@ @@Color.background.orange[500]@@ @@Color.background.yellow[600]@@ @@Color.background.green[500]@@ @@Color.background.green[700]@@ @@Color.background.gray[600]@@"
    }
  }
};